export default "__VITE_PUBLIC_ASSET__d9c02622__"